import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { subscribe, dismiss, getItems } from './toastBus';

const TYPE_STYLE = {
    success: {
        bg: 'bg-emerald-50 dark:bg-emerald-950/60 border-emerald-200 dark:border-emerald-800',
        icon: 'check_circle',
        iconColor: 'text-emerald-500',
        text: 'text-emerald-900 dark:text-emerald-100',
    },
    error: {
        bg: 'bg-red-50 dark:bg-red-950/60 border-red-200 dark:border-red-800',
        icon: 'error',
        iconColor: 'text-red-500',
        text: 'text-red-900 dark:text-red-100',
    },
    info: {
        bg: 'bg-blue-50 dark:bg-blue-950/60 border-blue-200 dark:border-blue-800',
        icon: 'info',
        iconColor: 'text-blue-500',
        text: 'text-blue-900 dark:text-blue-100',
    },
    warning: {
        bg: 'bg-amber-50 dark:bg-amber-950/60 border-amber-200 dark:border-amber-800',
        icon: 'construction',
        iconColor: 'text-amber-500',
        text: 'text-amber-900 dark:text-amber-100',
    },
};

export default function ToastContainer() {
    const [items, setItems] = useState(getItems());

    useEffect(() => subscribe(setItems), []);

    if (items.length === 0) return null;

    /* ⛔⛔ PORTAL KE <body> — WAJIB, bukan kemasan.
       Aduan user 2026-08-23: toast keluar TETAPI thumbnail video kad tercetak
       DI ATAS ayatnya, jadi pengguna nampak popup yang tidak boleh dibaca.

       Puncanya BUKAN warna toast (bg-*-50 memang legap). `position: fixed`
       hanya melompat keluar daripada aliran halaman — ia TIDAK melompat keluar
       daripada "konteks susunan" (stacking context). ToastContainer dirender
       jauh di dalam pokok WorkspaceView, dan mana-mana induk yang membawa
       transform / filter / opacity membuka konteks susunan sendiri; selepas itu
       z-index toast hanya bermakna DALAM kotak induk itu, dan seluruh kotak itu
       boleh duduk di bawah kad produk. Menaikkan nombor z-index sahaja TIDAK
       menyelesaikannya — itu perangkap yang mudah termakan.

       Portal ke <body> mengeluarkan toast daripada pokok itu sepenuhnya, jadi
       z-index di bawah dinilai pada peringkat halaman. Nombornya diletak ATAS
       modal (halaman ini ada modal pada z-9999/10000) kerana notifikasi mesti
       terbaca walaupun sebuah modal sedang terbuka.
       ⚠️ Jangan pulangkan ia ke dalam pokok komponen; simptomnya kembali dalam
          bentuk "popup kosong/terpotong" yang sukar dikaitkan dengan CSS. */
    return createPortal(
        <div className="fixed bottom-5 right-5 z-[100000] flex flex-col gap-2 pointer-events-none max-w-sm">
            {items.map(t => {
                const s = TYPE_STYLE[t.type] || TYPE_STYLE.info;
                return (
                    <div
                        key={t.id}
                        className={`pointer-events-auto flex items-start gap-2.5 px-3.5 py-2.5 rounded-xl border shadow-2xl animate-[toastSlideIn_0.22s_ease-out] ${s.bg}`}
                    >
                        <span className={`material-symbols-outlined text-[18px] ${s.iconColor} shrink-0 mt-0.5`}>{s.icon}</span>
                        <p className={`text-[12px] font-semibold leading-relaxed flex-1 ${s.text}`}>{t.message}</p>
                        <button
                            onClick={() => dismiss(t.id)}
                            className={`shrink-0 ${s.iconColor} opacity-50 hover:opacity-100 transition-opacity`}
                            aria-label="Dismiss"
                        >
                            <span className="material-symbols-outlined text-[14px]">close</span>
                        </button>
                    </div>
                );
            })}

            <style>{`
                @keyframes toastSlideIn {
                    from { opacity: 0; transform: translateX(20px) scale(0.96); }
                    to { opacity: 1; transform: translateX(0) scale(1); }
                }
            `}</style>
        </div>,
        document.body
    );
}
